import { api } from './api';

export interface Holiday { id: string; name: string; date: string; endDate: string | null; note: string | null; institutionId: string | null; }
export interface UpsertHoliday { name: string; date: string; endDate: string | null; note: string | null; institutionId: string | null; }

export const holidaysApi = {
  list: (year?: number) => api.get<Holiday[]>(`/api/holidays${year ? `?year=${year}` : ''}`),
  create: (b: UpsertHoliday) => api.post<Holiday>('/api/holidays', b),
  update: (id: string, b: UpsertHoliday) => api.put<Holiday>(`/api/holidays/${id}`, b),
  remove: (id: string) => api.del<void>(`/api/holidays/${id}`),
};
